import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProductAddProductModal } from "../components/productAddProductModal";
import { ProductMenuLayout } from "../layouts/ProductMenuLayout";
import { BrandInstance } from "../utils/brandClass";
import { BusinessInstance } from "../utils/businessClass";
import { Dashboard } from "./DashboardPage";


export const ProductsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);
  const [addScreenOpen, setAddScreenOpen] = useState(false);
  const [editScreenOpen, setEditScreenOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [product, setProduct] = useState(null);

  useEffect(() => {
    setEdit(false);
    setProduct(null);
  }, [addScreenOpen]);

  useEffect(() => {
    if (businesses.businessType !== "brand") {
      navigate("/menu");
    }
  }, [navigate, businesses.businessType]);

  const handleSelectBusiness = async (business: any) => {
    // console.log(business);
    await BusinessInstance.setBusiness(business);
  };

  const handleOpenAddProduct = () => {
    setAddScreenOpen(!addScreenOpen);
  };

  const handleEdit = (product: any) => {
    // Your edit handler
    setProduct(product);
    setEdit(true);
    setEditScreenOpen(true);
  };

  const handleDelete = async (product: any) => {
    // Your delete handler
    await BrandInstance.removeProduct(businesses.activeBusiness.id, product);
  };

  const handleFetchProducts = async () => {
    // Your fetch products handler
    await BrandInstance.getProducts(businesses.activeBusiness.id);
  };

  return (
    <Dashboard>
      {!addScreenOpen && !editScreenOpen && (
        <ProductMenuLayout
          handleAddProduct={handleOpenAddProduct}
          actions={{
            edit: handleEdit,
            // delete: handleDelete,
            get: handleFetchProducts,
          }}
        ></ProductMenuLayout>
      )}
      <>
        {editScreenOpen && (
          <ProductAddProductModal onClose={() => setEditScreenOpen(false)} product={product} isEditing={true} />
        )}
        {addScreenOpen && !editScreenOpen && (
          <ProductAddProductModal onClose={() => setAddScreenOpen(false)} product={product} isEditing={false} />
        )}
      </>
    </Dashboard>
  );
};
